// Generated by CoffeeScript 2.7.0
var AssignmentSettingsModalMixin;

export default AssignmentSettingsModalMixin = {
  props: {
    currentVertex: {
      type: Object
    },
    nextVertices: {
      type: Array
    },
    refuseVertices: {
      type: Array
    },
    nextGraphs: {
      type: Array
    },
    actionText: {
      type: String,
      default: '确认'
    },
    isTransferSetting: {
      type: Boolean,
      default: false
    },
    isRefuseSetting: {
      type: Boolean,
      default: false
    },
    journey: Object
  },
  data: function() {
    var ref, ref1;
    return {
      nextVertex: ((ref = this.nextVertices) != null ? ref[0] : void 0) || null,
      refuseVertex: ((ref1 = this.refuseVertices) != null ? ref1[0] : void 0) || null
    };
  },
  computed: {
    timeLimitSettingables: function() {
      var graph, graphsIncludeNextVertex, parent_id, ref, result, settingableGraphs;
      graphsIncludeNextVertex = [];
      if (this.nextGraphs.length) {
        graph = _.find(this.nextGraphs, (graph) => {
          return graph.id === this.nextVertex.graph_id;
        });
        if (graph) {
          graphsIncludeNextVertex.push(graph);
          while (graph.parent_id) {
            parent_id = graph.parent_id;
            graph = _.find(this.nextGraphs, function(graph) {
              return graph.id === parent_id;
            });
            if (!graph) {
              break;
            }
            graphsIncludeNextVertex.push(graph);
          }
        }
      }
      settingableGraphs = _.filter(graphsIncludeNextVertex, function(graph) {
        return graph.dig('settings', 'duration_threshold', 'enable_manual');
      });
      return result = ((ref = this.nextVertex) != null ? ref.dig('settings', 'duration_threshold', 'enable_manual') : void 0) ? settingableGraphs.reverse().concat(this.nextVertex) : settingableGraphs.reverse();
    },
    reviewerRemote: function() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(`yet_another_workflow/vertices/${this.nextVertex.id}/users.json`, {
        journey_id: this.journey.id
      });
    },
    refuseReviewersRemote: function() {
      return Skylark.Helpers.UrlHelper.namespaceUrlFor(`yet_another_workflow/vertices/${this.refuseVertex.id}/users/processed_reviewers.json`, {
        journey_id: this.journey.id
      });
    },
    nextVertexIsFinal: function() {
      return this.nextVertex.type === 'YetAnotherWorkflow::Vertex::Final';
    }
  },
  watch: {
    nextVertices: function(new_value) {
      return this.vertexChangedFunc(new_value[0] || null);
    },
    refuseVertices: function(new_value) {
      return this.refuseVertexChangedFunc(new_value[0] || null);
    }
  },
  methods: {
    vertexChangedFunc: function(vertex) {
      return this.nextVertex = vertex;
    },
    refuseVertexChangedFunc: function(vertex) {
      return this.refuseVertex = vertex;
    },
    updateSetting: function(options) {
      return _.extend(this, options);
    },
    open: function() {
      return this.$refs.modal.open();
    },
    close: function() {
      var ref;
      this.$refs.modal.close();
      if ((ref = this.spinner) != null) {
        ref.close();
      }
      return this.$emit('modalClosed');
    },
    getBaseData: function() {
      var carbonCopySetting, durationThresholdSetting, nextReviewerSetting, ref, ref1, ref2, ref3, ref4;
      nextReviewerSetting = ((ref = this.$refs.nextReviewerSettingRef) != null ? ref.getData() : void 0) || [];
      durationThresholdSetting = ((ref1 = this.$refs.durationThresholdSettingRef) != null ? ref1.getData() : void 0) || [];
      carbonCopySetting = ((ref2 = this.$refs.carbonCopySettingRef) != null ? ref2.getData() : void 0) || [];
      return {
        next_vertex_id: (ref3 = this.nextVertex) != null ? ref3.id : void 0,
        refuse_to_vertex_id: (ref4 = this.refuseVertex) != null ? ref4.id : void 0,
        next_reviewer_ids: nextReviewerSetting,
        duration_thresholds: durationThresholdSetting,
        carbon_copy_user_ids: carbonCopySetting
      };
    }
  }
};
